(function() { window.GUID_5ade735a_7f66_45c9_aed4_01b2f3299cc3 = { getGuid: function() { return "5ade735a-7f66-45c9-aed4-01b2f3299cc3"; } }; })();
//function LoadFile(fileType, filePath, callback) {
//    var scriptTag = document.createElement(fileType);
//    scriptTag.onload = function (loadEvent) {
//        if (callback != null) {
//            callback.call(this);
//        }
//    };
//    scriptTag.type = "text/javascript";
//    (<any>scriptTag).src = filePath + "?forcedownload=" + new Date().getTime();
//    document.getElementsByTagName("head")[0].appendChild(scriptTag);
//}

//# sourceMappingURL=cs.dynamicfile.js.map
